import React from 'react'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import useStores from '../../stores/useStore'
import { Observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'

const StyledCatalogViewSwitch = styled.div`
  margin-bottom: 25px;
  font-weight: bold;
`
const AllArticlesSwitch = () => {
    const { inventoryStore } = useStores()
    const { t } = useTranslation();

    return (<Observer>{() => (
        <StyledCatalogViewSwitch>
            <Form.Check
                type="switch"
                label={t('allArticles')}
                onChange={(e) => { inventoryStore.setShowAllArticles(e.target.checked)}}
                id="catalog-view-switch"
                checked={inventoryStore.showAllArticles}
            />
        </StyledCatalogViewSwitch>
    )}</Observer>)
}

export default AllArticlesSwitch
